<template>
  <div style="min-width:1280px;">
    <div class="jczl_div">
        <span class="jczl_span1">
          分析统计
        </span></br>
        <span class="jczl_span2">
          共拥有 {{proNum}} 个产品，闲置产品 {{proXZ}} 个，已过期 {{proGQ}} 个。
        </span>
        
        <div class="export">
          <span><a :href="href"><span class="el-icon-download"></span>导出统计数据</a></span>
        </div>
      </div>
    <div style="">
      <el-row :gutter="20">
        <el-col :span="6" >
          <div class="grid-content bg-purple icon_div" >
            <img  src="../../img/ZS.png" class="x_icon" /></br>
            <span class="span_size">产品总数</span></br>
            <span class="div_span zs">{{proNum}}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple icon_div">
            <img  src="../../img/XZ.png" class="x_icon" /></br>
            <span class="span_size">闲置产品</span></br>
            <span class="div_span xz">{{proXZ}}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple icon_div">
            <img  src="../../img/GQ.png" class="x_icon" /></br>
            <span class="span_size">已过期产品</span></br>
            <span class="div_span ygq">{{proGQ}}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple icon_div">
            <img  src="../../img/JGQ.png" class="x_icon" /></br>
            <span class="span_size">即将过期</span></br>
            <span class="div_span jgq">{{proJGQ}}</span>
          </div>
        </el-col>
      </el-row>
    </div>

    <div style="height:20px;"></div>
    <div >
      <el-row :gutter="20">
        <el-col :span="12" >
          <div class="grid-content bg-purple icon_div2">
            <div style='height:65px;'>
              <span class="cptj_span">积分统计</span>
              
              <div style="position:relative;float:right;right:10px;top:18px;">
                <el-select v-model="staTime" class="checkName" @change="changeTime">
                  <el-option v-for="item in times"  :label="item.text" :key="item.value" :value="item.value"> 
                  </el-option>
                </el-select>
              </div>
            
            </div>
            <div id="echartZXT" style="height:360px"></div>
          </div>
        </el-col>
        
        <el-col :span="12" >
          <div class="grid-content bg-purple icon_div2">
            <div style='height:65px;'>
              <span class="cptj_span">积分排行榜</span>
              <div style="position:relative;float:right;right:10px;top:18px;">
                <el-button class="jf_button" style="position:relative;left:15px;" @click="ranking(1)">全部</el-button>
                <el-button class="jf_button" @click="ranking(2)">近30天</el-button>
              </div>
            </div>
            <div v-if="masg2">
              <el-row style="width:100%;min-width:560px;" v-for="(val,index) in values" :key="index">
                <div style="padding:20px 0;">
                  <img v-if="!val.photo" src="../../img/person.png" class="rank_left rank_img"/>
                  <img v-else :src="val.photo" class="rank_left rank_img"/>
                  <div class="rank_left rank_name">{{val.name}} </div>
                  <div class="rank_left rank_sump">{{val.sumpoint}} </div>
                  <el-progress class="rank_num rank_left" :text-inside="true" :percentage="val.num" :show-text='false'
                    :stroke-width="15" :color="customColor">
                  </el-progress>
                  <div class="rank_right rank_jfDiv">
                      <span type="text" class="but_span" @click="handleLine(val.userid,val.name)">积分统计</span>
                  </div>
                  <img src="../../img/line.png" class="rank_right rank_lineImg rank_tjImg"/>
                  <div class="rank_right rank_mkDiv">
                    <span type="text" class="but_span" @click="handlePie(val.userid,val.name)">模块使用情况</span>
                  </div>
                  <img src="../../img/pie.png" class="rank_right rank_pieImg rank_tjImg"/>
                </div>
              </el-row>
              <el-col :span="24" style="margin-top:0;position:relative;top:10px;">
                <el-pagination 
                  layout="prev, pager, next"
                  :current-page="pageNumber" 
                  @current-change="handleCurrentChange" 
                  :page-size="pageSize" 
                  :total="total" 
                  style="float:right;">
                </el-pagination>
              </el-col>
            </div>
            <div v-else style="text-align:center;line-height:19;">无数据。。。</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="height:20px;"></div>
    <div >
      <el-row :gutter="20">
        <el-col :span="12" >
          <div class="grid-content bg-purple icon_div2">
            <div style='height:65px;'>
              <span class="cptj_span">产品统计</span>
            </div>
            <div class="div_div"></div>
            <div class="cptj_div">
              <div v-for="product in products" style="padding:20px 50px;">
                <img  :src="product.logo" class="cptj_img"/>
                <span :title="product.name" class="cptj_name">{{product.name}}</span>
                <span class="cptj_num" ><B>{{product.num}}</B></span>
                <div class="cptj_bottom"></div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12" >
          <div class="grid-content bg-purple icon_div2">
            <div style='height:65px;'>
              <span class="cptj_span">模块使用情况</span>
              <div style="position:relative;float:right;right:10px;top:18px;">
                <el-select v-model="staTime" class="checkName" @change="changeTime">
                  <el-option v-for="item in times"  :label="item.text" :key="item.value" :value="item.value"> 
                  </el-option>
                </el-select>
              </div>
              <!--<el-row>
                <el-select v-model="staTime" 
                   class="checkName" @change="changeTime">
                  <el-option v-for="item in times"  :label="item.text" :key="item.value" :value="item.value"> 
                  </el-option>
                </el-select>
                 <el-input v-show="person2 == '2'" style="width:100px;float: right;right:100px;top: -3px;" class="checkName " readonly="readonly" @click.native="handleUser(1)"
                  v-model="checkPerson2" placeholder="选择人员"></el-input>
                <el-select v-model="person2" disabled style="width:80px;float: right;right: 10px;top: -3px;" class="checkName" @change="changePerson2">
                  <el-option v-for="item in persons"  :label="item.text" :key="item.value" :value="item.value"> </el-option>
                </el-select> 
              </el-row>-->
            </div>
            <div v-show="!masg" id="echartBT" style=" height:360px"></div>
            <div v-show="masg" style="height:360px;text-align:center;line-height:20;"> 无数据。。。</div>
          </div>
   
        </el-col>
        
      </el-row>
    </div>
    <el-dialog class="model-edit" title="选择人员" :visible.sync="personVisible" 
      :close-on-click-modal="false">
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;border:1px solid #dfe6ec;">
        <el-form :inline="true" :model="souchs" @submit.native.prevent>
          <el-select v-model="souch_value" placeholder="请选择" @change="changeSouch"  style="width:120px;">
            <el-option v-for="item in optionsSouch" :key="item.value"  
              :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-form-item>
            <el-input  v-model="proName" style="width:200px;"  @keyup.enter.native="getUser(1)"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="getUser(1)">查询</el-button>
          </el-form-item>
        </el-form>
        <el-tag :key="tag" v-for="tag in dynamicTags" closable  :disable-transitions="false"
           @close="handleClose(tag)" > 
            {{tag}} 
        </el-tag>
        <el-button v-if="dynamicTags!=''" class="button-new-tag" size="small" @click="delTags">清除标签</el-button>
      </el-col>
      <!--用户列表-->
      <el-table  :data="users" highlight-current-row  style="width: 100%;" 
      ref="users" :header-cell-style="getRowClass" @current-change="handleSelectionChange">
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <input type="checkbox" v-model="scope.row.checked" @change="changeFun"> 
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="账号" min-width="130" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="name" label="姓名" min-width="100" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="point" label="积分"  min-width="120" show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="border:1px solid #dfe6ec;margin-top:0;">
        <el-pagination 
          layout=" prev, pager, next" :current-page="pageNumber2" @current-change="handleCurrentChange2" 
          :page-size="pageSize2"  :total="total2" style="float:right;">
        </el-pagination>
      </el-col>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click.native="personVisible = false">取消</el-button>
        <el-button type="primary" @click.native="userSubmit">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog class="model-edit" title="近30天模块使用" :visible.sync="pieVisible" 
      :close-on-click-modal="false">
      <span style="position:absolute;left:30px;top:60px;">当前人员 : {{pieName}}</span>
      <div id="echartBT2" style=" height:360px"></div>
    </el-dialog>
    <el-dialog class="model-edit" title="近30天积分统计" :visible.sync="lineVisible" 
      :close-on-click-modal="false">
      <span style="position:absolute;left:30px;top:60px;">当前人员 : {{lineName}}</span>
        <div id="echartZXT2" style=" height:360px"></div>
    </el-dialog>

  </div>
</template>
<script>
import { API__code,API_Company,API_Stat,} from '../../../api/index.js'
var echarts = require('echarts');
export default {
  props: ['defalutd'],

  data(){
    return {
      staTime:'1',
      lineVisible:false,
      pieVisible:false,
      pageNumber:1,
      pageSize:6,
      total:1,
      proCPlist:false,
      checkPerson2:'',
      person2:'1',
      funCheck:1,//1表示饼图，2折线
      products:[],
      proNum:0,
      proXZ:0,
      proGQ:0,
      proJGQ:0,
      optionsSouch:[
        {value: '账号',label: '账号'},
        {value: '姓名',label: '姓名'}, 
        {value: '积分',label: '积分'},
      ],
      checkCode:'',
      token:'',
      id:'',
      companyuseid:'',
      checkUser:'',
      checkUser2:'',
      checkUserId:"",
      checkUserId2:"",
      personVisible:false,
      pageSize2:10,
      pageNumber2:1,
      total2:1,
      users:[],
      times:[
        {value:'1',text:'最近一个月'},
        // {value:'0',text:'全部'},
      ],
      persons:[
				{ value: "1", text: "企业" },
				{ value: "2", text: "个人" },
      ],
      checkPerson:'',
      person:'1',
      values:[],
      // percentage:'',
      
      customColor: '#409eff',
      customColors: [
        {color: '#f56c6c', percentage: 20},
        {color: '#e6a23c', percentage: 40},
        {color: '#5cb87a', percentage: 60},
        {color: '#1989fa', percentage: 80},
        {color: '#6f7ad3', percentage: 100}
      ],
      flag:false,
      dynamicTags:[],
      proName:'',
      souchs:{},
      souch_value:'',
      dateTime:[],
      dataNum:[],
      masg:false,
      masg2:false,
      pieName:'',
      lineName:'',
      ranked:false,
      href:''
    }
  },
  methods:{
    handleLine:function(id,name){
      this.lineName = name;
      this.lineVisible = true;
      this.getUserMonthPointBrokenLine2(id);
    },
    handlePie:function(id,name){
      this.pieName = name;
      this.pieVisible = true;
      this.getCompanyUserMonthModulePointPie2(id);
    },
    handleCurrentChange:function(val){
      this.pageNumber = val;
      if(this.ranked){
        this.getCompanyUserMonthPointList();
      }else{
        this.getCompanyUserPointList();
      }
    },
    changePerson2:function(val){
      if(val == 1){
        this.getCompanyMonthModulePointPie();
      }else{
        if(this.checkUserId2){
          this.getCompanyUserMonthModulePointPie(this.checkUserId2);
        }
      }
    },
    changeTime:function(val){

    },
    // changePerson:function(val){
    //   if(val == 1){
    //     this.getCompanyMonthPointBrokenLine();
    //   }else{
    //     if(this.checkUserId){
    //       this.getUserMonthPointBrokenLine(this.checkUserId);
    //     }
    //   }
    // },
    userSubmit:function(){
      if(this.funCheck == 1){
        this.checkPerson2 = this.checkUser2;
        this.getCompanyUserMonthModulePointPie(this.checkUserId2);
      }else{
        this.checkPerson = this.checkUser;
        this.getUserMonthPointBrokenLine(this.checkUserId);
      }
      this.personVisible = false;
    },
    changeSouch:function(val){
      if(val == "姓名"){
        this.proName = this.souchs.name;
      }else if(val == "账号"){
        this.proName = this.souchs.phone;
      }else if(val == "积分"){
        this.proName = this.souchs.point;
      }
    },
    delTags2:function(){
      this.souchs = {};
      this.proName = '';
      this.dynamicTags = [];
      this.getUser();
    },
    handleClose(tag) {
      if(tag == "姓名"){
        this.souchs.name ="";
        if(this.souch_value == "姓名"){
          this.proName = '';
        }
      }
      if(tag == "账号"){
        this.souchs.phone ="";
        if(this.souch_value == "账号"){
          this.proName = '';
        }
      }
      if(tag == "积分"){
        this.souchs.point ="";
        if(this.souch_value == "积分"){
          this.proName = '';
        }
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleCurrentChange2(val) {
      this.pageNumber2 = val;
    },
    changeFun:function(){
      var falg = false;
      if(this.funCheck == 1){
        for(var i=0;i<this.users.length;i++){
          if(this.users[i].checked == true){
            falg = true;
            this.checkUserId2 = this.users[i].id;
          }
        }
        if(!falg){
          this.checkUserId2 = "";
        }
      }else{
        for(var i=0;i<this.users.length;i++){
          if(this.users[i].checked == true){
            falg = true;
            this.checkUserId = this.users[i].id;
          }
        }
        if(!falg){
          this.checkUserId = "";
        }
      }
    },
    handleSelectionChange (row) {
      this.flag = true;
      this.users.forEach(item => {
        if (item.id !== row.id) {
           item.checked = false;
        }
        if(item.id == row.id){
          item.checked = true;
        }
      });
      if(row.name  == null){
        row.name = "";
      }
      if(row.phone == null){
        row.phone = "";
      }
      if(this.funCheck == 1){
        this.checkUser2 = row.name;
        this.checkUserId2 = row.id;
      }else{
        this.checkUser = row.name;
        this.checkUserId = row.id;
      }
      
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0) {
          return "background:#F5F7FA";
      } else {
          return "";
      }
    },
    handleUser:function(val){
      this.funCheck = val;
      this.personVisible = true;
      this.getUser();
    },
    getUser:function(){
      let _this = this;
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        pageNumber:this.pageNumber2,
        pageSize:this.pageSize2,
        listType:'page',
        // invitestatus:'0',
        companyid:this.companyuseid
      }
      API_Company.userList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data){
            for(var i=0;i<res.data.data.list.length;i++){
              if(res.data.data.list[i]){
                if(_this.funCheck == 1){
                  if(_this.checkUserId2 && res.data.data.list[i].id == _this.checkUserId2){
                    res.data.data.list[i].checked = true;
                  }else{
                    res.data.data.list[i].checked = false;
                  }
                }else{
                  if(_this.checkUserId && res.data.data.list[i].id == _this.checkUserId){
                    res.data.data.list[i].checked = true;
                  }else{
                    res.data.data.list[i].checked = false;
                  }
                }
              }
            }
            _this.total2 = res.data.data.totalRow;
            _this.users = res.data.data.list;
          }
        }else{
          _this.$message.error(res.data.message);
          if(res.data.code == 403){
            _this.$router.push({path: 'login'});
          }
        }
      }).catch(err =>{
        _this.$message.error('数据丢失，试试重新登陆！');
      })
    },
    
    echart1 :function(dataTime,dataNumber){
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('echartZXT'));
      // 绘制图表
      myChart.setOption({
        // title : {
        //     text: '积分获取情况', //图名
        //     // subtext: '纯属虚构',//副名
        //     x:'center'
        // },
        tooltip: {
            trigger: 'axis'
        },
        grid: {
            top:'3%',
            left: '3%',
            right: '4%',
            bottom: '5%',
            containLabel: true
        },
        // toolbox: {
        //     feature: {
        //         saveAsImage: {}
        //     }
        // },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data:dataTime,
        },
        yAxis: {
            type: 'value',
            axisLine: {
                show: true,
                lineStyle: {
                    color: "rgba(219,225,255,1)",
                    width: 0,
                    type: "solid"
                }
            },
            axisLabel: {//y轴文字的配置
                textStyle: {
                     color: "#333333",
                     margin: 15
                },
               // formatter: '{value} %'//y轴的每一个刻度值后面加上‘%’号
            },
        },
        series: [
            {
                name:'积分',
                type:'line',
                stack: '总量',
                data:dataNumber,
            },
        ]
      });
    },
    echart4 :function(dataTime,dataNumber){
      var myChart = echarts.init(document.getElementById('echartZXT2'));
      myChart.setOption({
        tooltip: {
            trigger: 'axis'
        },
        grid: {
            top:'8%',
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data:dataTime,
        },
        yAxis: {
            type: 'value',
            axisLine: {
                show: true,
                lineStyle: {
                    color: "rgba(219,225,255,1)",
                    width: 0,
                    type: "solid"
                }
            },
            axisLabel: {//y轴文字的配置
                textStyle: {
                     color: "#333333",
                     margin: 15
                },
               // formatter: '{value} %'//y轴的每一个刻度值后面加上‘%’号
            },
        },
        series: [
            {
                name:'积分',
                type:'line',
                stack: '总量',
                data:dataNumber,
            },
        ]
      });
    },
    echart2:function(data1,data2){
      var myChart = echarts.init(document.getElementById('echartBT'));
      // 绘制图表
      myChart.setOption({
        // title : {
        //     text: '模块使用情况', //图名
        //     x:'center'
        // },
        tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
            bottom: 10,
            left: 'center',
            data:data1,
        },
        series : [
            {
                name: '模块名称',
                type: 'pie',
                radius : '55%',
                center: ['50%', '45%'],
                data:data2,
                itemStyle: {
                    emphasis: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    },
                    normal:{
                      color:function(params) {
                      //自定义颜色
                        var colorList = [          
                            '#CDDC39', '#E6EE9C', '#AEEA00', '#FFEA00', '#FFA000','#FFCC80',
                            '#F48FB1', '#FF5722', '#D50000', '#7B1FA2', '#7C4DFF','#B388FF',
                            '#3949AB', '#536DFE', '#8C9EFF', '#64B5F6', '#2196F3','#607D8B',
                            '#4CAF50', '#00E5FF','#64FFDA',
                        ];
                        return colorList[params.dataIndex]
                      }
                    }
                }
            }
        ]
      });
    },
    echart3:function(data1,data2){
      var myChart = echarts.init(document.getElementById('echartBT2'));
      // 绘制图表
      myChart.setOption({
        tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
            bottom: 10,
            left: 'center',
            data:data1,
        },
        series : [
          {
            name: '模块名称',
            type: 'pie',
            radius : '55%',
            center: ['50%', '45%'],
            data:data2,
            itemStyle: {
                emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                },
                normal:{
                  color:function(params) {
                  //自定义颜色
                    var colorList = [          
                        '#CDDC39', '#E6EE9C', '#AEEA00', '#FFEA00', '#FFA000','#FFCC80',
                        '#F48FB1', '#FF5722', '#D50000', '#7B1FA2', '#7C4DFF','#B388FF',
                        '#3949AB', '#536DFE', '#8C9EFF', '#64B5F6', '#2196F3','#607D8B',
                        '#4CAF50', '#00E5FF','#64FFDA',
                    ];
                    return colorList[params.dataIndex]
                  }
                }
            }
          }
        ]
      });
    },
    //读取cookie
    getCookie: function() {
      this.id = sessionStorage.getItem('dnnypt_id');
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('='); //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'dnnypt_token') {
              this.token = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == 'dnnypt_checkCode') {
              this.checkCode = arr2[1];
          }
          // else if (arr2[0] == 'dnnypt_id') {
          //     this.id = arr2[1];
          // }
        }
      }
    },
    //企业产品总数
    getProductSum:function(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        companyid:this.companyuseid,
      }
      API_Stat.getProductSum(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.length > 0){
            this.proNum = res.data.data[0].num;
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    //分类企业产品总数
    getGroupProductSum:function(){
      let _this = this;
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        companyid:this.companyuseid,
      }
      API_Stat.getGroupProductSum(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.length > 0){
            this.proCPlist = true;
            _this.products = res.data.data;
          }else{
            this.proCPlist = false;
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    //过期产品总数
    getDueProductSum:function(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        companyid:this.companyuseid,
      }
      API_Stat.getDueProductSum(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.length > 0){
            this.proGQ = res.data.data[0].num;
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    //闲置产品总数
    getUnusedProductSum:function(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        companyid:this.companyuseid,
      }
      API_Stat.getUnusedProductSum(param)
      .then((res) =>{
        
        if(res.data.code == API__code.SUCCESS){
          
          if(res.data.data.length > 0){
            this.proXZ = res.data.data[0].num;
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    //将过期产品总数
    getDueInMonthProductSum:function(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        companyid:this.companyuseid,
      }
      API_Stat.getDueInMonthProductSum(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.length > 0){
            this.proJGQ = res.data.data[0].num;
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    //企业个人总排行
    getCompanyUserPointList:function(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        companyid:this.companyuseid,

        pageNumber:this.pageNumber,
        pageSize:this.pageSize,
        listType:'page',
      }
      API_Stat.getCompanyUserPointList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.list.length>0){
            this.masg2 = true;
            for(var i=0;i<res.data.data.list.length;i++){
              if(res.data.data.list[i].sumpoint){
                res.data.data.list[i].num = parseInt((res.data.data.list[i].sumpoint/res.data.maxPoint)*100);
                if (res.data.data.list[i].num < 30) {
                  this.customColor = '#f56c6c';
                } else if (res.data.data.list[i].num < 70) {
                  this.customColor = '#5cb87a';
                } else {
                  this.customColor = '#67c23a';
                }
              }
            }
            this.values  = res.data.data.list;
            this.total = res.data.data.totalRow;
          }else{
            this.masg2 = false;
          }
          
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    //企业个人30天排行
    getCompanyUserMonthPointList:function(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        companyid:this.companyuseid,
        pageNumber:this.pageNumber,
        pageSize:this.pageSize,
        listType:'page',
      }
      API_Stat.getCompanyUserMonthPointList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.list.length > 0){
            this.masg2 = true;
            var allsumpoint = 0;
            for(var i=0;i<res.data.data.list.length;i++){
              if(res.data.data.list[i].sumpoint){
                res.data.data.list[i].num = parseInt((res.data.data.list[i].sumpoint/res.data.maxPoint)*100);
                if (res.data.data.list[i].num < 30) {
                  this.customColor = '#f56c6c';
                } else if (res.data.data.list[i].num < 70) {
                  this.customColor = '#5cb87a';
                } else {
                  this.customColor = '#67c23a';
                }
              }
            }
            this.values  = res.data.data.list;
            this.total = res.data.data.totalRow;
          }else{
            this.masg2 = false;
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    ranking:function(val){
      if(val == 1){
        this.ranked = false;
        this.getCompanyUserPointList();
      }else{
        this.ranked = true;
        this.getCompanyUserMonthPointList();
      }
    },
    //企业30天折线图
    getCompanyMonthPointBrokenLine:function(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        companyid:this.companyuseid,
      }
      API_Stat.getCompanyMonthPointBrokenLine(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.dateTime = [];
          this.dataNum = [];
          for(var i=0;i<res.data.data.length;i++){
            this.dateTime.push(res.data.data[i].date.substring(5).replace(/-/g,"月") + '日');
            this.dataNum.push(res.data.data[i].sumpoint);
          }
          this.echart1(this.dateTime,this.dataNum);
        }
      });
    },
    //个人30天折线图
    getUserMonthPointBrokenLine:function(id){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        userid:id,
      }
      API_Stat.getUserMonthPointBrokenLine(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.dateTime = [];
          this.dataNum = [];
          for(var i=0;i<res.data.data.length;i++){
            this.dateTime.push(res.data.data[i].date.substring(6));
            this.dataNum.push(res.data.data[i].sumpoint);
          }
          this.echart1(this.dateTime,this.dataNum);
        }
      });
    },
    //弹窗个人30天折线图
    getUserMonthPointBrokenLine2:function(id){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        userid:id,
      }
      API_Stat.getUserMonthPointBrokenLine(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.dateTime = [];
          this.dataNum = [];
          for(var i=0;i<res.data.data.length;i++){
            this.dateTime.push(res.data.data[i].date.substring(5).replace(/-/g,"月") + '日');
            this.dataNum.push(res.data.data[i].sumpoint);
          }
          this.echart4(this.dateTime,this.dataNum);
        }
      });
    },
    //企业模块饼图
    getCompanyMonthModulePointPie:function(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        companyid:this.companyuseid,
      }
      API_Stat.getCompanyMonthModulePointPie(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.length>0){
            this.masg = false;
          }else{
            this.masg = true;
          }
          var modulenames = [];
          var modul = [];
          for(var i=0;i<res.data.data.length;i++){
            modulenames.push(res.data.data[i].modulename);
            var json = {value:res.data.data[i].sumpoint, name:res.data.data[i].modulename}
            modul.push(json);
          }
          this.echart2(modulenames,modul);
          
        }
      });
    },
    //个人30天饼图
    getCompanyUserMonthModulePointPie:function(id){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        userid:id,
      }
      API_Stat.getCompanyUserMonthModulePointPie(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.length>0){
            this.masg = false;
          }else{
            this.masg = true;
          }
          var modulenames = [];
          var modul = [];
          for(var i=0;i<res.data.data.length;i++){
            modulenames.push(res.data.data[i].modulename);
            var json = {value:res.data.data[i].sumpoint, name:res.data.data[i].modulename}
            modul.push(json);
          }
          this.echart2(modulenames,modul);
        }
      });
    },
    //弹窗个人30天饼图
    getCompanyUserMonthModulePointPie2:function(id){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        userid:id,
      }
      API_Stat.getCompanyUserMonthModulePointPie(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.length>0){
            this.masg = false;
          }else{
            this.masg = true;
          }
          var modulenames = [];
          var modul = [];
          for(var i=0;i<res.data.data.length;i++){
            modulenames.push(res.data.data[i].modulename);
            var json = {value:res.data.data[i].sumpoint, name:res.data.data[i].modulename}
            modul.push(json);
          }
          this.echart3(modulenames,modul);
        }
      });
    },
 
  
  },
  
  mounted() {
    // this.echart1();
    // this.echart2();
    if(this.defalutd == 2){
      this.getProductSum();
      this.getGroupProductSum();
      this.getDueProductSum();
      this.getUnusedProductSum();
      this.getDueInMonthProductSum();
      this.getCompanyUserPointList();
      this.getCompanyMonthPointBrokenLine();
      this.getCompanyMonthModulePointPie();
    }
  },
  watch: {
    'defalutd': function (val) {
      if(val == 2){
        this.getProductSum();
        this.getGroupProductSum();
        this.getDueProductSum();
        this.getUnusedProductSum();
        this.getDueInMonthProductSum();
        this.getCompanyUserPointList();
        this.getCompanyMonthPointBrokenLine();
        this.getCompanyMonthModulePointPie();
      }
    }
  },
  created(){
    this.companyuseid = sessionStorage.getItem('companyuseid');
    this.getCookie();
    this.href = API_Company.exportPointExcel()+"?token="+this.token+"&checkCode="+this.checkCode+"&companyid="+sessionStorage.getItem('companyuseid')+"&count=1&companyname="+sessionStorage.getItem('company')+""; 
  }
}
</script>
<style scoped lang="scss">

  .el-col {
    border-radius: 4px;
  }
  /* .bg-purple-dark {
     background: #99a9bf; 
  } */
  .bg-purple {
    /* background: #d3dce6; */
    border:1px solid #d3dce6;
  }
  /*.bg-purple-light {
     background: #e5e9f2; 
  }*/
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
    /* padding: 20px; */
    /* height: 150px; */
  }
  .row-bg {
    padding: 10px 0;
    /* background-color: #f9fafc; */
  }
  .x_icon{
    /* font-size: 80px; */
    position: relative;
    text-align: center;
    left: 0;
    height:54px;
    width:54px;
    padding-top: 15px;
  }
  .icon_div{
    text-align:center;
    position: relative;
    height: 164px;
    background: #fff;
  }
  .icon_div2{
    /* text-align:center; */
    position: relative;
    height: 420px;
    min-width: 630px;
    background: #fff;
  }
  .div_span{
    font-size: 28px;
    font-weight: Bold;
    position: relative;
    top:25px;
  }
  .zs{
    /* color:#409eff; */
    color:#577CCC;
  }
  .ygq{
    /* color:#E6A23C; */
    color:#FCA63F;
  }
  .xz{
    /* color:#67C23A; */
    color:#55BF3C;
  }
  .jgq{
    color:#38C8CD;
    /* color:#F56C6C; */
  }
  .span_size{
    font-size: 16px;
    position: relative;
    top: 10px;
  }
  .span_num{
    position: absolute;
    float: right;
    right:10px;
    top:10px;
    font-size: 30px;
    color: slategray;
    z-index: 99;
  }
  .rank_span{
    width: 20%;
    position: relative;
    float: right;
    padding-top: 3px;
    padding: 5px;
    top: -3px;
  }
  .rank_span2{
    position: absolute;
    top: 4px;
    float: right;
    right: 30%;
    z-index: 9;
  }
  .rank_num{
    padding: 5px;
    width: 35%;
    position: relative;
    float: left;
    left:5.5%;
  }
  .checkName{
    /* width:120px; */
    position: absolute;
    /* z-index: 2000; */
    width:115px;
    /* float: right; */
    right: 10px;
    top: -3px;
  }
  .souc{
    position: absolute;
    left: 90px;
  }
  .x_icon2{
    font-size: 60px;
    position: relative;
    text-align: center;
    left: 0;
    height: 60px;
    padding-bottom: 10px;
  }
  .cpName{
    width:100%;
    overflow: hidden;
    display:block;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .div_cp{
    border-top: 1px dashed darkgray;
    border-bottom: 1px dashed darkgray;
    margin-top: 20px;
    padding-bottom: 15px;
    background-color: #f9fafc;
  }
  .span_cp{
    position: absolute;
    width:55px;
    background: #f2f9ff;
    padding-left: 10px;
    top: -12px;
    font-size: 18px;
    left: 20px;
  }
  .cptj_span{
    position:relative;
    left:20px;
    top:20px;
    font-size:16px;
    color:#333333;
    font-weight: Medium;
  }
  .div_div{
    width:80%;
    position:relative;
    left:10%;
    height:1px;
    background:#EFF0F2;
  }
  .cptj_div{
    height:350px;
    overflow-x:auto;
  }
  .cptj_img{
    height:36px;
    width:36px;
  }
  .cptj_name{
    position: relative;
    left: 20px;
    top: -11px;
    font-size:18px;
    color:#333333;
  }
  .cptj_num{
    position: relative;
    right: 20px;
    top:12px;
    float:right;
    font-size:20px;
    color:#333333;
  }
  .cptj_bottom{
    position:relative;
    height:1px;
    background:#EFF0F2;
    top:15px;
  }
  .jf_button{
    width: 100px;
    height: 30px;
    line-height: 0;
  }
  .rank_left{
    position:relative;
    float:left;
  }
  .rank_img{
    left:3.5%;
    width:28px;
    height: 28px;
  }
  .rank_name{
    left:4.5%;
    top:3px;
    width:7.5%;
  }
  .rank_sump{
    left:4.5%;
    top:4.5px;
    width:7.5%;
  }
  .rank_right{
    position:relative;
    float:right;
  }
  .rank_jfDiv{
    right:10px;
    top:-5px;
    width:80px;
  }
  .rank_lineImg{
    right:15px;
  }
  .rank_mkDiv{
    right:30px;
    top:-6px;
  }
  .rank_pieImg{
    right:30px;
  }
  .rank_tjImg{
    width:24px;
    height:24px;
    border:1px dashed #FF6383;
  }
  .jczl_div{
    height: 100px;
    width: 100%;
    position: relative;
    left: 20px;
  }
.jczl_span1{
  font-size:20px;
  color:#666;
  font-weight:bold;
  position: relative;
  top:20px;
}
.jczl_span2{
  font-size:14px;
  color:#666;
  font-weight:normal;
  position: relative;
  top:30px;
}
.but_span{
  position:relative;
  top:8px;
  cursor:pointer;
  color:#666;
}

.export{
  float: right;
  color: #2196F3;
  font-size: 14px;
  position: relative;
  top: 3px;
  background: #fff;
  width: 142px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  right:20px;
  cursor: pointer;
  a{
    text-decoration: none;
    color: #2196F3;
  }
}
</style>



// WEBPACK FOOTER //
// Statistics.vue?8b7a3242